import React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { LoadingButton } from '@mui/lab';
import moment from 'moment';
import Label from '../../../components/label/Label';

const TAX_RATE = 0.07;

function ccyFormat(num) {
  return `${num.toFixed(2)}`;
}

function priceRow(qty, unit) {
  return qty * unit;
}

function createRow(desc, qty, unit) {
  const price = priceRow(qty, unit);
  return { desc, qty, unit, price };
}

function subtotal(items) {
  return items.map(({ price }) => price).reduce((sum, i) => sum + i, 0);
}

const rows = [
  createRow('Paperclips (Box)', 100, 1.15),
  createRow('Paper (Case)', 10, 45.99),
  createRow('Waste Basket', 2, 17.99),
];

const invoiceSubtotal = subtotal(rows);
const invoiceTaxes = TAX_RATE * invoiceSubtotal;
const invoiceTotal = invoiceTaxes + invoiceSubtotal;

export default function UserPersonalInformation({ data }) {
  return (
    <TableContainer component={Paper}>
      <Table aria-label="spanning table">
        <TableHead>
          <TableRow>
            <TableCell>User Property</TableCell>
            <TableCell align="right">Value</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell>Full Name</TableCell>
            <TableCell align="right">{data.name}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Email</TableCell>
            <TableCell align="right">{'--'}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Mobile Number</TableCell>
            <TableCell align="right">{data.email}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Registration Date</TableCell>
            <TableCell align="right">{moment(data.createdAt).format('MMMM Do YYYY, hh:mm:ss a')}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Last Profile Update Date</TableCell>
            <TableCell align="right">{moment(data.updatedAt).format('MMMM Do YYYY, hh:mm:ss a')}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>User Status</TableCell>
            <TableCell align="right">
              <Label color={data.isBlocked ? 'error' : 'success'}>{data.isBlocked ? 'Blocked' : 'Active'}</Label>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Admin Status</TableCell>
            <TableCell align="right">
              <Label color={data.isAdmin ? 'error' : 'success'}>{data.isAdmin ? 'ADMIN' : 'USER'}</Label>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Contact</TableCell>
            <TableCell align="right">
              <LoadingButton
                onClick={() => window.open(`https://wa.me/91${data.email}`)}
                style={{ marginRight: 10 }}
                size="small"
                type="submit"
                variant="contained"
                color="success"
              >
                Whatsapp Call
              </LoadingButton>

              <LoadingButton
                onClick={() => window.open(`tel:${data.email}`)}
                size="small"
                type="submit"
                variant="contained"
              >
                Phone Call
              </LoadingButton>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
}
